<template>
	<div class="element-wrapper pb-2">
		<div class="element-search autosuggest-search-activator">
			<div class="search-suggest-input">
				<input v-on:focus="openSearch" v-model="search" :placeholder="place" type="text">
			</div>

			<div class="search-with-suggestions-w over-search-field" :class="showBox">
				<div class="search-with-suggestions-modal">
					<div class="element-search">
						<input style="display: none" class="search-suggest-input" v-model="search" :placeholder="place" type="text">
						<div class="close-search-suggestions"><i v-on:click="closeSearch" class="os-icon os-icon-x"></i></div>
					</div>
					<div class="search-suggestions-group" v-if="events">
						<div class="ssg-header">
							<div class="ssg-icon">
								<div class="os-icon os-icon-calendar-time"></div> {{ t.navigation.matches }} ({{ events.length }})
							</div>
						</div>
						<div class="ssg-content">
							<div class="ssg-items ssg-items-list">
								<router-link v-if="!live" :to="{ name: 'Sportsbook', query: {c: event.competition.id}, params: { event: event.id } }" class="ssg-item" v-on:click="selectUser(user)" v-for="event in events" :key="event.id">
                  <div class="item-name">{{ event.player1.name | slimiter(20) }} - {{ event.player2.name | slimiter(20) }}
										<span class="competition-title">
                      <img data-v-6b101666="" :src="'/static/assets/img/'+event.competition.sport.alias+'.png'" loading="lazy" width="24" height="24" class="SportTitle-styles-sport-icon">
                      {{ event.competition.name | slimiter(28) }}
                    </span>
										{{ event.startDate | moment('DD.MM HH:mm', session.timezone) }}

                    <img src="/static/assets/img/live_icon.gif" width="50" v-if="event.onLive"/>
									</div>
								</router-link>

                <a v-if="live" href="javascript:;" @click="openMatch(event)" :to="{ name: 'LiveBet', params: { sport: event.competition.sport.id, competition: event.competition.id } }" class="ssg-item" v-on:click="selectUser(user)" v-for="event in events" :key="event.id">
                  <div class="item-name">{{ event.player1.name | slimiter(14) }} - {{ event.player2.name | slimiter(14) }}
                    <br />
                    <span><div class="sport-icon mr-2"><sportIcon :color="'#818ba7'" :sport="event.competition.sport.id"/></div> {{ event.competition.name | slimiter(28) }}</span>
                    <br />
                    {{ event.startDate | moment('DD.MM HH:mm', session.timezone) }}
                  </div>
                </a>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import sportIcon from '@/components/ui/asset/sportIcon';
    export default {
        name: 'eventSearch',
	    components: {sportIcon},
        props: {
            live: {
              Type: String,
              default: ''
            },
            place: {
                Type: String,
                default: 'Search...'
            },
            group: {
                Type: String,
                default: 'Client'
            }
        },
        data () {
            return {
                session: session,
                t: this.$root.t,
                api: window.api,
                search: '',
                show: false,
                events: null,
                total: 0,
                selected: null
            }
        },
        watch: {
            '$route' () {
                this.show = false;
            },
            search () {
                this.fetchUsers();
            }
        },
        computed: {
            showBox () {
                return (this.show) ? 'show' : 'hide';
            }
        },
        methods: {
            openMatch(m) {
              this.$bus.$emit('openMatchOdd', m)
            },
            openSearch () {
                this.show = true;
                this.events = null;
                this.search = ''
            },
            closeSearch () {
                this.show = false;
                this.search = ''
            },
            selectUser (user) {
                this.selected = null;
                this.$emit('selected', user);
                this.selected = user;
                this.closeSearch();
            },
            fetchUsers () {
                this.$http.get(bsapi+'api/v1/search/fixture', {params: {q: this.search, raw: false, live: this.live} }).then(response => {
                    // get body data
                    this.events = response.body.result;
                    this.total  = response.body.result.length;
            }, response => {

                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

	.search-with-suggestions-w.over-search-field.show {
		display: block
	}
	.search-with-suggestions-w.over-search-field.hide {
		display: none
	}
	.search-with-suggestions-w.over-search-field {
		top: 70px;
		width: 100%;
		max-height: 550px;
		overflow: auto;
    position: absolute;
    border-radius: 2px;
    background-color: var(--white);
    box-shadow: 0 0 2px 0 rgba(var(--black-box-shadow-rgb),.14),0 1px 3px 0 rgba(var(--black-box-shadow-rgb),.14);
  }
	.autosuggest-search-activator {
		position: relative;
	}
	.ssg-items .sport-icon {
		width: 15px;
		height: 15px;
		float: left
	}
	.search-with-suggestions-w .search-with-suggestions-modal {
		background-color: #fff;
		border-radius: 4px;
		-webkit-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
		box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
		padding: 10px;
		position: relative;

	}

	.element-wrapper .element-search input {
		border-radius: 0px;
	}

  .element-wrapper .element-search input{
    border: 1px solid #7c7c7c;
    background: white;
  }

  .competition-title {
    width: 100%;
    display: block;
    opacity: 0.8;
  }

  .search-suggest-input input {
    background: none !important;
    border: 0px !important;
    border-bottom: 1px solid white !important;
    color: white;
    margin-top: 30px;
    width: 100%;
    padding: 5px;
  }

  .ssg-items-list a{
    width: 100%;
    color: var(--header-bg) !important;
    position: relative;
    display: flex;
    align-items: center;
    padding: 16px 32px 16px 16px;
    border-bottom: 1px solid var(--grey-iron);
    line-height: 1.4;
    cursor: pointer;
    border-radius: 2px;
    background-color: var(--white);
    box-shadow: 0 0 2px 0 rgba(var(--black-box-shadow-rgb),.14),0 1px 3px 0 rgba(var(--black-box-shadow-rgb),.14);

  }



  .element-wrapper {
    top: -15px;
    width: 300px;
    position: absolute;
    margin-left: 40px;
    background: var(--header-bg);
    z-index: 5;
  }

  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: white;
    opacity: 1; /* Firefox */
  }

  .item-name {
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/widget/eventSearch.vue